module.exports = __webpack_public_path__ + "static/media/salt_black.fb7fa2c2.svg";